export const toDoCard = {
  updateModalTitle: 'To-do bearbeiten',
  updateModalButtonText: 'Anpassen',
  deleteModalTitle: 'Sind Sie sicher, dass Sie Ihr To-do löschen möchten?',
  deleteModalButtonText: 'Löschen',
  updateErrorToastText: 'To-do konnte nicht aktualisiert werden.',
  deleteErrorToastText: 'To-do konnte nicht gelöscht werden.',
  changeStatusErrorToastText: 'To-do-Status konnte nicht geändert werden.',
}
